import loginCartoonFall from "../../assets/icons/login/loginCartoonFall.png";

// THIS IS WHERE YOU CHANGE THE LOGIN SCREEN GRAPHIC
// this lets us just change it in one spot instead of remembering to do it everywhere it's used
const loginGraphic = loginCartoonFall;

export default loginGraphic;
